import React, { FC } from "react";
import { useTranslation } from "i18n";
import { IconTextLink } from "../../Atoms/IconTextLink/IconTextLink";

interface Props {
  onClick: (e: any) => void;
  className?: string;
  iconButton?: boolean;
}

const ContactPerformerButton: FC<React.PropsWithChildren<Props>> = ({
  onClick,
  className = "text-color-brand-two font-semibold max-w-fit",
  iconButton = false,
}) => {
  const { t } = useTranslation();
  const text = t("common:contactPerformerModal.label.contactButton");

  return iconButton ? (
    <IconTextLink
      className={className}
      onClick={onClick}
      iconName="icon-messages"
      text={text}
      variant="primary"
    />
  ) : (
    <button className={className} onClick={onClick} type="button">
      {text}
    </button>
  );
};

export default ContactPerformerButton;
